function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.23,12.43v2H10.1A1.53,1.53,0,0,0,8.57,16v0h0v8.45A1.53,1.53,0,0,0,10.08,26H21.9a1.55,1.55,0,0,0,1.53-1.54V16a1.55,1.55,0,0,0-1.53-1.54h0v-2a5.84,5.84,0,1,0-11.62-1.17h0a4.58,4.58,0,0,0,0,1.17Zm6.68,8.16a.29.29,0,0,0-.15.3v1.86h0a.66.66,0,0,1-.35.63.72.72,0,0,1-1-.27.88.88,0,0,1-.1-.36h0V20.89a.29.29,0,0,0-.14-.29,1.42,1.42,0,0,1-.46-1.74,1.44,1.44,0,0,1,1.92-.71,1.46,1.46,0,0,1,.85,1.28A1.41,1.41,0,0,1,16.91,20.59Zm-4.13-8.16a3.27,3.27,0,0,1,6.53,0v2H12.78Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.f8945236.svg";
export { ForwardRef as ReactComponent };